export const enLearnLocale = {
  home_header_title: 'Lessons',
  lesson_title: 'Lesson {{lessonNumber}}',
  task_number: 'Task {{taskNumber}} of {{totalTasks}}',
  pronunciation_grader_initialization_failed: 'Failed to initialize pronunciation grader',
  check_answer_failed: 'Failed to check answer',

  // SpeechSuper Grading Messages
  evaluation_timeout: 'Evaluation timed out',
  grader_not_initialized: 'Grader must be initialized before starting',
  grader_not_initialized_audio: 'Grader must be initialized before sending audio',
  grader_not_initialized_stop: 'Grader must be initialized before stopping',
  unsupported_grader_type: 'Unsupported grader type: {{type}}',

  // SpeechSuper Connection Messages
  connection_error: 'Connection error: {{message}}',
  connection_closed: 'Connection closed unexpectedly',
  connection_parse_error: 'Failed to parse response: {{message}}',

  // Phoneme Grader Messages
  grader_busy: 'Grader is already recording or grading',
  grader_initialization_failed: 'Failed to get grading parameters',
  grader_not_started: 'Grader is not recording or grading',
  no_correct_pronunciation: 'No correct pronunciation found in grading parameters',

  // Help Manager
  help_manager_help_question:
    "Hmmm, this seems like a tough one. Maybe you're doing it right, and I'm just not understanding you. Do you want to skip to the next one?",
  help_manager_feedback_question: 'My apologies! Sorry about that. Can you tell me what you think went wrong?',
  help_manager_retry: "OK. Let's try again, and I'll try to understand you better this time.",
  help_manager_complete_step_as_correct:
    "OK, thank you for sharing with me. I appreciate it. I'll count this one as correct and then we can move to the next one.",

  // Retry after error
  retry_after_error: "I didn't hear you say anything. Let's try again.",

  // Sounds Writing
  check_writing_failed: 'Failed to check writing',

  // Lessons Completed
  lessons_completed_title: 'All lessons completed!',

  // Capital Letters
  capital_letters_uppercase_letter: 'capital',
  capital_letters_lowercase_letter: 'small',

  // Encouragement
  encouragement_error_handling_message: 'Hmmm, I forgot what I was going to say. Keep going!',

  // Step Restart
  step_restart_message: 'Let me remind you what to do',
};
